import { definePath } from '../../router/definePath';

export const HomeNetworkPaths = {
  overview: definePath('authenticated', { de: '/konto/heimnetz', en: '/account/home-network' }),
} as const;
